import PropTypes from "prop-types"

const SimplePlaceholder = ({ 
  classNames = {},
  children, 
  icon: Icon, 
  isFullHeight = true, 
  title 
}) => (
  <div className={`${classNames?.wrapper || ""} relative flex flex-col items-center justify-center w-full ${isFullHeight ? 'h-full' : ''} p-12 text-center border-2 border-gray-300 border-dashed rounded-lg`}>
    <Icon className="w-24 h-24 mb-2 text-indigo-800 dark:text-content2-foreground" />
    <span className="block text-lg font-semibold text-foreground">{title}</span>
    {children && children}
  </div>
)

SimplePlaceholder.propTypes = {
  children: PropTypes.node,
  classNames: PropTypes.object,
  icon: PropTypes.object.isRequired,
  isFullHeight: PropTypes.bool,
  title: PropTypes.string.isRequired,
}

export default SimplePlaceholder
